<mbs-wizards-installation-step [buildsSelectionConfig]="buildsSelectionConfig"
                               (hasError)="onboardingService.hasError$.next($event)"
                               (stable)="onboardingService.stable$.next($event)"
                               [view]="installationView"></mbs-wizards-installation-step>
